export interface BaseState {
    _isFetching: boolean,
    _isPatching: boolean,
    _isCreating: boolean,
    _isDeleting: boolean,
    _forceFetch: boolean,
    ids: any[],
    entities: {}
}

export interface BaseReducerState<T> extends BaseState {
    _isFetchingPage: number[],
    _isFiltering: boolean,
    statistics: any,
    pagination: {
        page_number: number,
        total_pages: number,
        records: number,
        internal_pages: {}
    },

    valuesByEntityIdByFieldId: { },
    datasets: {
        _isFetching: boolean,
        _forceFetch: boolean,
        ids: any[],
        entities: { }
    }
}




export const baseState = {
    _isFetching: false,
    _isPatching: false,
    _isCreating: false,
    _isDeleting: false,
    _forceFetch: true,
    ids: [],
    entities: { }
}

export const baseReducerState = {
    ...baseState,
    _isFetchingPage: [],
    _isFiltering: false,
    statistics: {},
    pagination: {
        page_number: 1,
        total_pages: 1,
        records: 0,
        internal_pages: {}
    },

    valuesByEntityIdByFieldId: { },
    datasets: {
        _isFetching: false,
        _forceFetch: true,
        ids: [],
        entities: { }
    }
}